import { Injectable } from '@angular/core';
import { GlobalLookupTypesCache, MetadataProvider } from 'app/model';
import { BusyService, EntityManagerProvider } from '../services';

@Injectable({
  providedIn: 'root',
})
export class NotificationsEntityManagerProvider extends EntityManagerProvider {
  constructor(metadataProvider: MetadataProvider, busyService: BusyService, lookupTypesCache: GlobalLookupTypesCache) {
    super(metadataProvider.metadataStore, '', busyService, {
      lookupTypesCache,
    });
  }
}
